import { Card } from './card';

export function SectionCard({
	title,
	action,
	children,
}: {
	title: string;
	action?: React.ReactNode;
	children: React.ReactNode;
}) {
	return (
		<Card className="overflow-hidden border-line-1 bg-surface gap-0 py-0">
			<div className="flex items-center justify-between border-b border-line-1 px-4 py-3">
				<h3 className="text-sm font-medium uppercase tracking-[0.04em] text-text-1">
					{title}
				</h3>
				{action && (
					<div className="[&>button]:flex [&>button]:h-6 [&>button]:cursor-pointer [&>button]:items-center [&>button]:gap-1.5 [&>button]:rounded-md [&>button]:bg-transparent [&>button]:px-2 [&>button]:text-sm [&>button]:font-medium [&>button]:text-text-2 [&>button]:transition-colors hover:[&>button]:bg-surface-fill hover:[&>button]:text-text-1">
						{action}
					</div>
				)}
			</div>
			{children}
		</Card>
	);
}
